/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Faq_Start_AInputs */

const en_platform_faq_start_a = /** @type {(inputs: Platform_Faq_Start_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`About fifteen minutes. You sign up, set the hours you work and what you offer, and your page is live at your own address. Clients can book from it straight away.`)
};

const pl_platform_faq_start_a = /** @type {(inputs: Platform_Faq_Start_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Około piętnastu minut. Rejestrujesz się, ustawiasz godziny pracy i to, co oferujesz, a Twoja strona jest już pod Twoim adresem. Podopieczni mogą z niej rezerwować od razu.`)
};

/**
* | output |
* | --- |
* | "About fifteen minutes. You sign up, set the hours you work and what you offer, and your page is live at your own address. Clients can book from it straight a..." |
*
* @param {Platform_Faq_Start_AInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_faq_start_a = /** @type {((inputs?: Platform_Faq_Start_AInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Faq_Start_AInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_faq_start_a(inputs)
	return en_platform_faq_start_a(inputs)
});